//import { useSelector } from "react-redux";
import { IonButtons, IonContent, IonHeader, IonIcon, IonImg, IonMenuButton, IonPage, IonText, IonTitle, IonToolbar } from "@ionic/react";
import { heart } from "ionicons/icons";
import React from "react";
import MainTabBar from "../components/MainTabBar";
import process from "../../package.json";

import "./About.css";

const About: React.FC = () => {
    // const isServiceWorkerUpdated = useSelector((state: any) => state.serviceWorkerUpdated);
    
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton></IonMenuButton>
                    </IonButtons>
                    <IonTitle>Bar Gambero</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent forceOverscroll={true}>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">Informazioni</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <div className="ion-padding">
                    <h4 style={{ marginBottom: "5px" }}>
                        <strong>Informazioni Covid-19</strong>
                    </h4>
                </div>
                <IonImg src={"assets/images/covid-ferma-il-virus.png"} />
                <div className="ion-padding">
                    <ul style={{ lineHeight: "1.25" }}>
                        <li>Utilizza sempre la mascherina in maniera corretta.</li>
                        <li>Lava ed igienizza le mani.</li>
                        <li>Rispetta la distanza di almeno 1 metro dagli altri.</li>
                        <li>Rimani seduto al tuo tavolo e goditi la compagnia, veniamo noi a servirti.</li>
                        <li>Scarica l'app Immuni, utile al tracciamento.</li>
                    </ul>
                    <p className="ion-text-left">
                        <a href="https://www.immuni.italia.it/download.html" target="_blank" rel="noopener noreferrer">
                            <IonImg src={"assets/images/immuni-logo.png"} style={{ height: "50px", width: "139px" }} />
                        </a>
                    </p>
                    <h4 style={{ marginBottom: "5px" }}>
                        <strong>Credits:</strong>
                    </h4>
                    <IonText color="medium">
                        <small>
                            <strong>Menù Online!</strong> I tuoi ordini dal tavolo e per l'asporto.
                            <br />
                            V. {process.version} Made with{" "}
                            <span style={{ color: "#f00", fontSize: "1.2em" }}>
                                <IonIcon icon={heart} />
                            </span>{" "}
                            by{" "}
                            <a href="http://www.ofcn15.com" target="_blank" rel="noopener noreferrer">
                                <IonImg src={"assets/images/OFCN15-logo-h50.png"} style={{ height: "20px", width: "75px", display: "inline-block", position: "relative", top: "4px" }} />
                            </a>
                            {/* <br />
                            <p>isServiceWorkerUpdated: {JSON.stringify(isServiceWorkerUpdated)}</p> */}
                        </small>
                    </IonText>
                    <p></p>
                </div>
            </IonContent>
            <MainTabBar />
        </IonPage>
    );
};

export default About;
